import { Avatar, Box, Button, Dialog, DialogActions, Grid, IconButton } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "styled-components";

interface IProps {
  open: boolean;
  onConfirm: () => any;
  onClose: () => any;
}

const style = {
  height: "150px",
  width: "530px",
  bgcolor: "#FFFFFF",
  boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.16)",
  borderRadius: "8px",
  p: 4,
};

const PageTitle = styled.legend`
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
`;

const ActionButton = styled(Button)`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  padding: 12px 16px;
`;

export const RefreshSessionDialog = ({ open, onConfirm, onClose }: IProps) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="confirm-dialog">
      <Box sx={style}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={1}>
            {
              <Avatar sx={{ backgroundColor: "#FEF1F2" }}>
                <ErrorOutlineIcon sx={{ color: "#881113" }} />
              </Avatar>
            }
          </Grid>
          <Grid item xs={10}>
            <PageTitle>Refresh session?</PageTitle>
          </Grid>
          <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                color: "#414141",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        <p>Refreshing your session will discard any changes you have made.</p>
        <DialogActions sx={{ paddingRight: "0px", paddingTop: "24px", paddingBottom: "16px" }}>
          <ActionButton variant="outlined" onClick={onClose}>
            Cancel
          </ActionButton>
          <ActionButton variant="contained" onClick={onConfirm}>
            Refresh session
          </ActionButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
